import { AlertMessage, Spinner } from "../../../../widgets";
import { useEffect, useState } from "react";

import { IPageLink } from "../../../../base/models";
import { IPageView } from "../../../page/models";
import { PageMode } from "../../../../base/types";
import { PageViewer } from "../../../page";
import { useGetPageMetadataQuery } from "../../../../services/data";

export const PartPage = ({ pageId, pageLink, className }: {
    pageId: string,
    pageLink: IPageLink,
    className?: string
}) => {
    const { data: page, isLoading, isSuccess, isError, error } = useGetPageMetadataQuery(pageId);
    const [pageView, setPageView] = useState<IPageView>()

    useEffect(() => {
        if (!pageLink)
            return;

        const { systemId, filters } = pageLink
        setPageView({ systemId, pageMode: PageMode.View, linkFilters: filters })
    }, [pageLink])

    return <>
        <div className="d-flex justify-content-center">
            <Spinner show={isLoading} />
        </div>

        <AlertMessage
            show={isError}
            type="Error"
            message={(error as any)?.data?.error?.message || `Failed to load the page id: ${pageId}`} />

        {(isSuccess && page && pageView) && <>
            <PageViewer className={className} page={page} pageView={pageView} showTitle={false} showRefresh={false} />
        </>}
    </>
}